import { Navigate, Route, Routes } from "react-router-dom";
import { Departments, ComingSoon, ConnectEmail, Welcome } from "../pages/Onboarding";
import EmailAndPassword from "@/pages/Onboarding/EmailAndPassword";
import { OAuthCallback } from "../pages/OAuthCallback";

const AuthRoutes = () => {
  return (
    <Routes>
      {/* OAuth callback — handles redirect from Google */}
      <Route path="/auth" element={<OAuthCallback />} />

      {/* Onboarding */}
      <Route path="/onboarding" element={<Welcome />} />
      <Route path="/departments" element={<Departments />} />
      <Route path="/connect-email" element={<ConnectEmail />} />
      <Route path="/email-password" element={<EmailAndPassword />} />
      <Route path="/coming-soon" element={<ComingSoon />} />

      {/* Default redirect */}
      <Route path="*" element={<Navigate to="/onboarding" replace />} />
    </Routes>
  );
};

export default AuthRoutes;
